export const exportToCsv = ({ filename, headers, data }) => {
    // Escape CSV fields that contain commas, quotes, or newlines
    const escapeField = (field) => {
        const str = String(field !== null && field !== void 0 ? field : '');
        if (str.includes(',') || str.includes('"') || str.includes('\n')) {
            return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
    };
    const csv = [
        headers.map(escapeField).join(','),
        ...data.map((row) => row.map(escapeField).join(',')),
    ].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};
export const formatCoinType = (coinType) => {
    if (!coinType)
        return 'Unknown';
    const parts = coinType.split('::');
    return parts[parts.length - 1] || coinType;
};
// Helper to format TokenAmount for CSV
const formatTokenAmount = (token) => {
    return `${token.amountFormatted || token.amountRaw} ${token.symbol}`;
};
// Helper to format multiple TokenAmounts
const formatTokenAmounts = (tokens) => {
    if (!tokens || tokens.length === 0)
        return '';
    return tokens.map(formatTokenAmount).join('; ');
};
// Transaction-specific CSV formatter
export const createTransactionCsvData = (transactions, positionCapId) => {
    const headers = [
        'Timestamp',
        'Type',
        'Digest',
        'Is PTB',
        'Actions',
        'Deposits',
        'Withdrawals',
        'Borrows',
        'Repayments',
        'Rewards Claimed',
        'Rewards Re-deposited',
        'Rewards Locked',
        'Liquidation - Collateral Liquidated',
        'Liquidation - Collateral Seized',
        'Liquidation - Debt Repaid',
        'Liquidation - Protocol Fee',
        'Liquidation - Liquidator Bonus',
        'Closing Net Worth Tokens',
        'Closing Net Worth USD',
        'Closing Health Factor',
    ];
    const data = transactions.map((tx) => {
        let deposits = '';
        let withdrawals = '';
        let borrows = '';
        let repayments = '';
        let rewardsClaimed = '';
        let rewardsRedeposited = '';
        let rewardsLocked = '';
        let collateralLiquidated = '';
        let collateralSeized = '';
        let debtRepaid = '';
        let protocolFee = '';
        let liquidatorBonus = '';
        // Process each summary in the transaction to format the data
        tx.summaries.forEach((summary) => {
            if (summary.action === 'Deposit') {
                const depositSummary = summary;
                deposits = formatTokenAmounts(depositSummary.tokens);
            }
            else if (summary.action === 'Withdraw') {
                const withdrawSummary = summary;
                withdrawals = formatTokenAmounts(withdrawSummary.tokens);
            }
            else if (summary.action === 'Borrow') {
                const borrowSummary = summary;
                borrows = formatTokenAmounts(borrowSummary.tokens);
            }
            else if (summary.action === 'Repay') {
                const repaySummary = summary;
                repayments = formatTokenAmounts(repaySummary.tokens);
            }
            else if (summary.action === 'CollectRewards') {
                const rewardsSummary = summary;
                rewardsClaimed = formatTokenAmounts(rewardsSummary.rewards);
                rewardsRedeposited = formatTokenAmounts(rewardsSummary.deposited);
                rewardsLocked = formatTokenAmounts(rewardsSummary.locked);
            }
            else if (summary.action === 'Liquidation') {
                const liqSummary = summary;
                collateralLiquidated = formatTokenAmounts(liqSummary.liquidatedTokens);
                collateralSeized = formatTokenAmounts(liqSummary.collateralSeized);
                debtRepaid = formatTokenAmounts(liqSummary.debtRepaid);
                protocolFee = formatTokenAmounts(liqSummary.protocolFee);
                liquidatorBonus = formatTokenAmounts(liqSummary.liquidatorBonus);
            }
        });
        // Format closing net worth tokens (now using TokenAmount[])
        const closingNetWorthTokens = tx.closingNetWorthTokens
            ? tx.closingNetWorthTokens
                .map((token) => {
                const rawAmount = parseFloat(token.amountRaw);
                // Use pre-formatted amount if available, otherwise format here
                const formatted = token.amountFormatted || token.amountRaw;
                const sign = rawAmount < 0 ? '-' : '';
                return `${sign}${formatted} ${token.symbol}`;
            })
                .join('; ')
            : '';
        const closingNetWorthUsd = tx.closingNetWorthUsd ? `$${tx.closingNetWorthUsd.toFixed(2)}` : '';
        const closingHealthFactor = tx.closingHealthFactor ? tx.closingHealthFactor.toFixed(4) : '';
        const actionTypes = tx.types.join(', ');
        return [
            new Date(tx.timestamp).toISOString(),
            tx.types.join(','),
            tx.digest,
            tx.isPTB ? 'Yes' : 'No',
            actionTypes,
            deposits,
            withdrawals,
            borrows,
            repayments,
            rewardsClaimed,
            rewardsRedeposited,
            rewardsLocked,
            collateralLiquidated,
            collateralSeized,
            debtRepaid,
            protocolFee,
            liquidatorBonus,
            closingNetWorthTokens,
            closingNetWorthUsd,
            closingHealthFactor,
        ];
    });
    const filename = `alphalend_transactions_${positionCapId === null || positionCapId === void 0 ? void 0 : positionCapId.slice(-8)}_${new Date().toISOString().split('T')[0]}.csv`;
    return { headers, data, filename };
};
